import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class SubgroupService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getAllSubgroup(): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + 'reportmaster/getsubgroups').pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getSubgroup(id: number,isMaintenance: boolean = true): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `reportmaster/getsubgroupbyid?id=${id}&isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  createSubgroup(subgroup: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster/createsubgroup', subgroup).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  updateSubgroup(subgroup: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'reportmaster/updatesubgroup', subgroup).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `reportmaster/deletesubgroup?id=${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }


  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'reportmaster/authorisesubgroup', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFilteredSubGroup(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'reportmaster/reportsubgroupfilter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

}
